import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ["payment-update"];

  static targets = ["cardBrand", "cardExpiryMonth", "cardExpiryYear", "cardLast4", "token"];

  static values = {
    datacapApiToken: String,
  };

  connect() {
    this.paymentUpdateOutlet.addAsyncSubmitInterrupt(this.handleSubmit.bind(this));

    const styles = `
      body {
        margin: 0;
        font-family: "Inter var", ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"
      }

      .container {
        width: 100%;
      }

      #payment_form {
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: .75rem;
      }

      .row {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
        min-width: 0;
      }

      .card-data {
        border-color: rgb(208 213 221/var(--tw-border-opacity,1));
        border-radius: .5rem;
        border-style: solid;
        border-width: 1px;
        box-sizing: border-box;
        color: rgb(52 64 84 / var(--tw-text-opacity, 1));
        font-size: 1rem;
        height: 40px;
        line-height: 1.5rem;
        margin: 2px;
        padding: 0 1rem;
        width: 100%;
      }

      .row-card-data-number {
        flex: 0 0 49%;
        width: 100%;
      }

      .row-card-data-number .right-col {
        width: 100%
      }

      .row-card-data-exp-month,
      .row-card-data-exp-year,
      .row-card-data-cvv {
          flex: 1;
      }

      .card-data-cvv {
        margin-left: 0;
      }

      .left-col label {
        font-size: .875rem;
        font-weight: 500;
        line-height: 1.25rem;
        --tw-text-opacity: 1;
        color: rgb(52 64 84 / var(--tw-text-opacity, 1));
      }
    `;

    DatacapHostedWebToken.init(
      this.datacapApiTokenValue,
      "datacap-cc-iframe",
      this.requestTokenCallback.bind(this),
      styles
    );

    this.paymentUpdateOutlet.enableSubmit();
  }

  handleSubmit() {
    return new Promise((resolve) => {
      this.submitResolve = resolve;

      DatacapHostedWebToken.requestToken();
    });
  }

  requestTokenCallback(response) {
    if (response.Error) {
      this.handleTokenError(response);
    } else {
      this.handleTokenSuccess(response);
    }
  }

  handleTokenSuccess(response) {
    this.tokenTarget.value = response.Token;
    this.cardBrandTarget.value = response.Brand;
    this.cardExpiryMonthTarget.value = response.ExpirationMonth;
    this.cardExpiryYearTarget.value = response.ExpirationYear;
    this.cardLast4Target.value = response.Last4;

    this.submitResolve(true);
    this.submitResolve = null;
  }

  handleTokenError(response) {
    this.paymentUpdateOutlet.setCustomError(response.Error);

    this.submitResolve(false);
    this.submitResolve = null;
  }
}
